import Component from '../abstracts/Component';

export default class DropdownComponent extends Component {

  get SELECTORS() {
    return {
      generic: '.dropdown'
    };
  }

  get CLASSES() {
    return {
      show: 'show'
    };
  }

  constructor() {
    super();
    this.timeout = null;
    this.dropdowns = $(this.SELECTORS.generic);
  }

  clickOutBackdrop() {
    // on click sul backdrop aperto
    this.$on('click.backdrop', ({
      event
    }) => {
      this.forceClose();
    }, 'body', '.backdrop-header.visible');
  }

  forceClose() {
    const main = document.querySelectorAll(this.SELECTORS.generic);
    main.forEach(el => {
      this.$emit(this.$customEvents.DROPDOWN_EVENTS.close, {
        source: el,
        res: 'lg'
      });
    });
  }

  bindEvents() {

    this.clickOutBackdrop();

    // gestisco il close generico delle modali con l'escape
    this.dropdowns.each((index, element) => {
      $(element).on("keydown", (e) => {
       const currentDropdown = e.currentTarget;
       if (e.which == 27 || e.keyCode == 'Escape') {
         e.preventDefault();
         if (currentDropdown.classList.contains(this.CLASSES.show)) {
           // faccio l'emit del close
           this.$emit(this.$customEvents.DROPDOWN_EVENTS.close, {
             source: currentDropdown,
             res: 'lg',
             escaped: true,
           });
         }
       }
     });
    });

    // gestico l'open generico delle modali
    this.$on(this.$customEvents.DROPDOWN_EVENTS.open, ({
      event,
      payload
    }) => {

      this.log('open modal');
      let el = payload.source;

      clearTimeout(this.timeout);

      if (payload.res == 'lg') {
        this.timeout = setTimeout(() => {
          el.classList.add(this.CLASSES.show);
          el.classList.add('hovered');
          $('.backdrop-header').addClass('visible');
        }, 300);
      }

    });

    // gestico il close generico delle modali
    this.$on(this.$customEvents.DROPDOWN_EVENTS.close, ({
      event,
      payload
    }) => {

      this.log('close modal');
      let el = payload.source;
      clearTimeout(this.timeout);

      if (payload.res == 'lg') {
        const input = el.querySelector('input:focus');
        if (!input || payload.escaped) {
          el.classList.remove(this.CLASSES.show);
          $('.backdrop-header').removeClass('visible');
          this.timeout = setTimeout(() => {
            el.classList.remove('item-added');
            el.classList.remove('hovered');
            el.classList.remove('notify');
          }, 300);
        }
      }

    });

    // gestisco il close di tutti i dropdown
    this.$on(this.$customEvents.DROPDOWN_EVENTS.closeAll, () => {
      this.forceClose();
    });
  }

  render() {
    this.bindEvents();
  }
}
